import { ReactNode } from 'react';
import { atom } from 'recoil';

const ATOM_KEY = 'modalConfirmState';

export interface ModalConfirmState {
  isVisible: boolean;
  title?: ReactNode | null;
  contents: ReactNode | null;
  confirmText?: ReactNode;
  cancelText?: ReactNode;
  onClickConfirm?: () => Promise<any> | void;
  onClickCancel?: () => Promise<any> | void;
}

export const DEFAULT_MODAL_CONFIRM_STATE = {
  isVisible: false,
  title: null,
  contents: null,
  confirmText: '확인',
  cancelText: '취소',
  onClickConfirm: undefined,
  onClickCancel: undefined
};

export const modalConfirmState = atom<ModalConfirmState>({
  key: ATOM_KEY,
  default: DEFAULT_MODAL_CONFIRM_STATE
});
